// import { selectChatThreads } from 'containers/Chats/chatSlice'
import { ReactComponent as Help } from 'assets/helpBig.svg'
import { ReactComponent as Alert } from 'assets/alert.svg'
import BigCircleBtn from 'components/buttons/BigCircleBtn'
import CircleBtn from 'components/buttons/CircleBtn'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectConfig } from 'appSlice'
import CallBtn from './CallBtn'
import { v7 } from 'uuid'

const Actions = ({ showFaq/* , expanded, expand */ }) => {
  // const threads = useSelector(selectChatThreads)
  const config = useSelector(selectConfig)

  const { push } = useHistory()
  const { t } = useTranslation('help')

  return (
    <div className='menu__buttons --top'>
      <CircleBtn
        text={t('write')}
        Icon={Alert}
        action={() => {
          // if (!expanded && checkIsAnyActiveThread(threads)) {
          //   expand(true)
          // } else {
            push(`/chat/${v7()}${window.location.search}`)
          // }
        }} />

      {config?.phoneSupport
        ? <BigCircleBtn
          interior={t('call')}
          action={() => {
            window.location.href = `tel:${config.phoneSupport}`
          }}
        />
        : <CallBtn />}

      <CircleBtn
        text='FAQ'
        Icon={Help}
        action={showFaq} />
    </div>
  )
}

// const checkIsAnyActiveThread = (threads) => {
//   if (threads) {
//     for (const id in threads) {
//       if (!threads[id].closed_at) return true
//     }
//   }
//   return false
// }

export default Actions